import { useState, useCallback } from "react";
import validateFile from "../Components/Common/FilesRelevent/validateFile";
import { urtoast } from "../Components/Layouts/CustomPopup/eventEmitter";

/**
 * Custom hook to handle file validation logic globally.
 * @returns {Object} { validating, validateFiles }
 */
export const useFileValidator = () => {
    const [validating, setValidating] = useState(false);

    /**
     * Validates one or more files using the backend API.
     * @param {File|File[]} files - The files to validate.
     * @returns {Promise<boolean>} - True if validation passes, false otherwise.
     */
    const validateFiles = useCallback(async (files) => {
        if (!files || (Array.isArray(files) && files.length === 0)) return true;

        setValidating(true);
        try {
            const result = await validateFile(files);
            if (!result.status) {
                urtoast(result.message || "Invalid file signature.", 2);
                setValidating(false);
                return false;
            }
            setValidating(false);
            return true;
        } catch (error) {
            console.error("Global validation hook error:", error);
            urtoast("Validation service error", 2);
            setValidating(false);
            return false;
        }
    }, []);

    return { validating, validateFiles };
};

export default useFileValidator;
